// -----------------------------------------------------------------------------

import dayjs from "dayjs";

import { CumulativeDailyFindings } from "stores/DashboardStore";

export default function getLineData(
  data: CumulativeDailyFindings[] = [],
  isOpen: boolean = false,
  startDate: Date,
  endDate: Date
) {
  if (data.length === 0) return [];

  let ret = data.map((curr: CumulativeDailyFindings) => {
    return {
      timestamp: curr.snap_timestamp,
      x: dayjs(curr.snap_timestamp).format("MM/DD"),
      y: isOpen ? curr.open_findings : curr.resolved_findings,
    };
  });

  // Backfill all dates between startDate and endDate that have no data
  const diff = dayjs(endDate).diff(startDate, "days");
  for (let i = 0; i <= diff; i++) {
    const curDate = dayjs(startDate).add(i, "day");
    const indexOfDate = ret.findIndex((r) =>
      dayjs(r.timestamp).isSame(curDate, "day")
    );

    if (indexOfDate === -1) {
      ret.push({
        timestamp: curDate.toDate(),
        x: curDate.format("MM/DD"),
        y: 0,
      });
    }
  }

  ret = ret.sort(
    (a, b) => dayjs(a.timestamp).valueOf() - dayjs(b.timestamp).valueOf()
  );

  return [{ id: `${isOpen ? 1 : 0}-findingsOverTime`, data: ret, color: "" }];
}
